module.exports = __webpack_public_path__ + "assets/img/thirdPrize.2e6f6624.png";